/**
 * Calculates the next scheduled weekly refresh date/time in user's local timezone
 * @param dayOfWeek - Day name (e.g., 'monday', 'tuesday')
 * @param hourUTC - Hour in UTC (0-23)
 * @returns Formatted string like "04/05/2026 - 5 AM EST"
 */
export function getNextWeeklyRefreshDisplay(
  dayOfWeek: 'sunday' | 'monday' | 'tuesday' | 'wednesday' | 'thursday' | 'friday' | 'saturday',
  hourUTC: number
): string {
  // Map day names to JavaScript day numbers (0 = Sunday, 1 = Monday, etc.)
  const dayMap: Record<string, number> = {
    sunday: 0,
    monday: 1,
    tuesday: 2,
    wednesday: 3,
    thursday: 4,
    friday: 5,
    saturday: 6,
  };
 
  const targetDay = dayMap[dayOfWeek.toLowerCase()];
  if (targetDay === undefined) {
    throw new Error(`Invalid day: ${dayOfWeek}`);
  }
 
  // Get current date/time
  const now = new Date();
  
  // Create the next occurrence in UTC
  const nextRun = new Date();
  nextRun.setUTCHours(hourUTC, 0, 0, 0);
  
  // Calculate days until target day
  const currentDay = now.getUTCDay();
  let daysUntil = targetDay - currentDay;
  
  // If target day has passed this week, or it's today but time has passed
  if (daysUntil < 0 || (daysUntil === 0 && now.getUTCHours() >= hourUTC)) {
    daysUntil += 7;
  }
  
  nextRun.setUTCDate(now.getUTCDate() + daysUntil);
 
  // Format date part (MM/DD/YYYY)
  const month = String(nextRun.getMonth() + 1).padStart(2, '0');
  const day = String(nextRun.getDate()).padStart(2, '0');
  const year = nextRun.getFullYear();
  
  // Format time part in user's local timezone
  const localHour = nextRun.getHours();
  const hour12 = localHour % 12 || 12;
  const ampm = localHour >= 12 ? 'PM' : 'AM';
  
  // Get timezone abbreviation e.g. GMT+8
  // const timeZoneAbbr = new Intl.DateTimeFormat('en-US', {
  //   timeZoneName: 'short',
  // })
  //   .formatToParts(nextRun)
  //   .find((part) => part.type === 'timeZoneName')?.value || '';
 
  return `${month}/${day}/${year} - ${hour12} ${ampm}`;
}